import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createVNode("div", { class: "mb-10" }, [
  /*#__PURE__*/_createVNode("h1", { class: "anchor fw-bolder mb-5" }, [
    /*#__PURE__*/_createVNode("a", { href: "#loading" }),
    /*#__PURE__*/_createTextVNode(" Loading ")
  ]),
  /*#__PURE__*/_createVNode("div", { class: "py-5" }, " Show animation while loading data. ")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EUILoadingInsideAContainer = _resolveComponent("EUILoadingInsideAContainer")
  const _component_EUICustomization = _resolveComponent("EUICustomization")
  const _component_EUIFullScreenLoading = _resolveComponent("EUIFullScreenLoading")
  const _component_EUIService = _resolveComponent("EUIService")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _hoisted_1,
    _createVNode(_component_EUILoadingInsideAContainer),
    _createVNode(_component_EUICustomization),
    _createVNode(_component_EUIFullScreenLoading),
    _createVNode(_component_EUIService)
  ], 64))
}